<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="name">Username</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Username"
                  v-model="user_name"
                  @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="name">Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Name"
                  v-model="full_name"
                  @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="name">Email</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Email"
                  v-model="email"
                  @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>            
<!--            <b-col md="3">-->
<!--              <b-form-group>-->
<!--                <label for="name">Company Name</label>-->
<!--                <input-->
<!--                  type="text"-->
<!--                  class="form-control"-->
<!--                  placeholder="Enter Company Name"-->
<!--                  v-model="company"-->
<!--                  @keyup.enter="doFilter"-->
<!--                />-->
<!--              </b-form-group>-->
<!--            </b-col>-->
            <b-col md="3">
              <b-form-group>
                <label for="name">User Role</label>
                <select
                  @keyup.enter="doFilter"
                  v-model="user_role"
                  class="form-control"
                >
                  <option value="">--PLEASE SELECT--</option>
                  <option
                    v-for="(role, index) in role_list"
                    :value="role.id"
                    :key="index"
                    >{{ role.name }}</option
                  >
                </select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="name">Status</label>
                <select v-model="status" class="form-control">
                  <option value="">Choose</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer" class="search-panel-btn">
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              class="search-btn"
              @click="doFilter"
              ><i class="cui-magnifying-glass icons"></i> Search</b-button
            >
            <b-button
              type="reset"
              size="sm"
              variant="danger"
              @click="resetFilter"
              ><i class="cui-ban icons"></i> Reset</b-button
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      user_name: "",
      full_name: "",
      user_role: "",
      email: "",
      company: "",
      roles: [],
      status:""
    };
  },
  computed: {
    ...mapState("user", ["role_list"])
  },
  methods: {
    ...mapActions("user", ["getRoleList"]),
    doFilter() {
      let filters = {
        user_name: this.user_name,
        full_name: this.full_name,
        user_role: this.user_role,
        company: this.company,
        email: this.email,
        status: this.status
      };
      this.$events.fire("filter-set", filters);
    },
    resetFilter() {
      this.user_name = "";
      this.full_name = "";
      this.user_role = "";
      this.company = "";
      this.email = "";
      this.status = "";
      this.$events.fire("filter-reset");
    },
    async RoleList() {
      await this.getRoleList();
      this.roles = this.role_list;
    }
  },
  mounted() {
    this.RoleList();
  }
};
</script>

<style scoped>
.search-panel-btn {
  float: right;
}

.search-btn {
  margin-right: 5px;
}
</style>
